import React, {useState} from 'react';
import API from '../../services/api-service.jsx';
import './contact-form.css'

const ContactForm = ({
    formTitle="CONTACT US", 
    showWithTwoColumns=true, 
    detailsTitle="title",
    phone="phone", 
    fax="fax", 
    email="email", 
    address="address",
    addressLink="addressLink"}) => {
        
        const [nameInput, setNameInput] = useState("")
        const [emailInput, setEmailInput] = useState("")
        const [phoneNumberInput, setPhoneNumberInput] = useState("")
        const [messageInput, setMessageInput] = useState("")
        const [errorMsg, setErrorMsg] = useState("")
        const [successMsg, setSuccessMsg] = useState("")

        const isReadyToSubmit = () => {
            return nameInput?.length > 0 && emailInput?.length > 0 && phoneNumberInput && messageInput
        }

        const handleSubmit = (e) => {
            e.preventDefault()
            if(isReadyToSubmit()){
                API.sendEmail(nameInput, emailInput, phoneNumberInput, messageInput)
                    .then((res) => {
                        setEmailInput("")
                        setNameInput("")
                        setPhoneNumberInput("")
                        setMessageInput("")
                        setSuccessMsg("Successfully submited form! We will get in touch with you soon.")
                        setTimeout(() => {
                            setSuccessMsg("")
                        }, 5000);

                    })
                    .catch((err) => {
                        setErrorMsg("Failed to submit form. Try again or send us an email directly or give us a call.")
                        console.log(err)
                        setTimeout(() => {
                            setErrorMsg("")
                        }, 5000);
                    })
            }
        }

        const gridClass = showWithTwoColumns? "col-sm-12 col-md-6" : "col-12"

        return (
            <div className="contact-form-wrapper row">
                <div className={`${gridClass}`}>
                    <legend className="center bold underline">{detailsTitle}</legend>
                    <div className="contact-info">
                        <span className="fas fa-envelope">
                            <strong> Email:</strong> 
                            <p className="contact-detail">
                                <a href={`mailto:${email}`} className="default-link">
                                    {email}
                                </a>
                            </p>
                        </span>
                    </div>
                    <div className="contact-info">
                        <span className="fas fa-phone">
                            <strong> Phone:</strong> 
                            <p className="contact-detail">
                                <a href={`tel:${phone}`} className="default-link">{phone}</a>
                            </p>
                        </span>
                    </div>
                    <div className="contact-info">
                        <span className="fas fa-phone">
                            <strong> Fax:</strong> 
                            <p className="contact-detail">
                                <a href={`tel:${fax}`} className="default-link">{fax}</a>
                            </p>
                        </span>
                    </div>
                    <div className="contact-info">
                        <span className="fas fa-map-pin">
                            <strong> Location:</strong> 
                            <p className="contact-detail">
                                <a href={addressLink} target="_blank" rel="noreferrer" className="default-link">
                                    {address}
                                </a>
                            </p>
                        </span>
                    </div>
                </div>
                <div className={`${gridClass} parallax contact-form`}>
                    <legend className="center bold">{formTitle}</legend>
                    <label htmlFor="inputContactName" className="form-label">Name:</label>
                    <input type="text" placeholder='Name' 
                        value={nameInput}
                        onChange={(e) => setNameInput(e.target.value)} 
                        id="inputContactName" 
                        className="form-control" />
                    <label htmlFor="inputContactEmail" className="form-label">Email:</label>
                    <input type="text" placeholder='Email' 
                        value={emailInput}
                        onChange={(e) => setEmailInput(e.target.value)} 
                        id="inputContactEmail" 
                        className="form-control" />
                    <label htmlFor="inputContactPhone" className="form-label">Phone Number:</label>
                    <input type="text" placeholder='Phone Number' 
                        value={phoneNumberInput}
                        onChange={(e) => setPhoneNumberInput(e.target.value)} 
                        id="inputContactPhone" 
                        className="form-control" />
                    <label htmlFor="inputContactDescription" className="form-label">Question / Comment:</label>
                    <textarea id="inputContactDescription" 
                        value={messageInput}
                        onChange={(e) => setMessageInput(e.target.value)} 
                        placeholder='Enter your question or comment here...' 
                        rows="3" 
                        className="form-control"/>
                    <button type="submit" 
                        onClick={handleSubmit} 
                        disabled={!isReadyToSubmit()} 
                        className="btn btn-success form-control margin-top-5">Submit</button>
                    {errorMsg?
                        <div className="alert alert-danger d-flex align-items-center alert-msg" role="alert">
                            <svg className="bi flex-shrink-0 me-2" width="24" height="24" role="img" aria-label="Danger:">
                                <use xlinkHref="#exclamation-triangle-fill"/></svg>
                            <div>
                                {errorMsg}
                            </div>
                        </div> : ""
                    }
                    {successMsg?
                        <div className="alert alert-success d-flex align-items-center alert-msg" role="alert">
                            <svg className="bi flex-shrink-0 me-2" width="24" height="24" role="img" aria-label="Success:">
                                <use xlinkHref="#check-circle-fill"/></svg>
                            <div>
                                {successMsg}
                            </div>
                        </div> : ""
                    }
                </div>
            </div>
        )
}

export default ContactForm;
